/** @format */

import React, { useState, useEffect } from "react";
import Leave_request_table from "./leave_request_table";
import { RiUserReceived2Line } from "react-icons/ri";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { RxCrossCircled } from "react-icons/rx";
import Cookies from "js-cookie";
import { motion, AnimatePresence } from "framer-motion";
import Select from "react-select";

const Leave_Request = () => {
  const [leaveCounts, setLeaveCounts] = useState({
    received: 0,
    accepted: 0,
    rejected: 0,
  });

  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState("");

  const API_URL = process.env.REACT_APP_FRONTEND_URL;

  // 🔹 Fetch organizations dropdown
  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const token = Cookies.get("user_token");
        const res = await fetch(`${API_URL}/v1/hris/organizations/organization`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          credentials: "include",
        });
        const json = await res.json();
        if (json.success && Array.isArray(json.data)) {
          setOrganizationOptions(
            json.data.map((org) => ({
              value: org.id,
              label: org.organization_name,
            }))
          );
        }
      } catch (err) {
        console.error("Error fetching organizations:", err);
      }
    };
    fetchOrganizations();
  }, [API_URL]);

  // 🔹 Fetch summarized leave counts
  useEffect(() => {
    const fetchLeaveSummary = async () => {
      const token = Cookies.get("user_token");
      try {
        const orgParam = selectedOrganization || ""; // optional
        const response = await fetch(
          // `${API_URL}/v1/hris/leave/getLeaveCountByDate?date=${today}`,
          `${API_URL}/v1/hris/leave/summery-leave?organization=${orgParam}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        const result = await response.json();
        if (result.success && result.data) {
          const { APPROVED, REJECTED, NOT_APPROVED } = result.data;

          setLeaveCounts({
            received: Number(NOT_APPROVED || 0), // Pending = NOT_APPROVED
            accepted: Number(APPROVED || 0),
            rejected: Number(REJECTED || 0),
          });
        }


      } catch (error) {
        console.error("Error fetching leave summary:", error);
      }
    };

    fetchLeaveSummary();
  }, [API_URL, selectedOrganization]);

  // 🔹 Animation Variants
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.3, ease: "easeOut" },
    }),
  };

  const cards = [
    {
      icon: <RiUserReceived2Line />,
      value: leaveCounts.received,
      label: "Pending Leave Requests",
      gradient: "from-purple-600 to-indigo-600",
      tooltip: "Total leave requests pending",
    },
    {
      icon: <IoShieldCheckmarkOutline />,
      value: leaveCounts.accepted,
      label: "Approved Leave Requests",
      gradient: "from-green-500 to-teal-500",
      tooltip: "Leave requests approved",
    },
    {
      icon: <RxCrossCircled />,
      value: leaveCounts.rejected,
      label: "Rejected Leave Requests",
      gradient: "from-red-500 to-pink-500",
      tooltip: "Leave requests rejected or not approved",
    },
  ];

  return (
    <div className="mx-auto font-montserrat mt-5">
      {/* Header */}
      <div className="flex justify-between items-center mt-6">
        <div>
          <p className="text-[25px] text-gray-800">Leave Requests</p>
        </div>

        {/* Organization Filter */}
        <div className="w-64">
          <Select
            options={organizationOptions}
            placeholder="Select Organization"
            value={
              organizationOptions.find(
                (opt) => opt.value === Number(selectedOrganization)
              ) || null
            }
            onChange={(opt) =>
              setSelectedOrganization(opt ? opt.value : "")
            }
            isClearable
            classNamePrefix="select"
          />
        </div>
      </div>

      {/* Statistics Section */}
      <div className="bg-white/80 backdrop-blur-md mt-6 p-2 rounded-xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <AnimatePresence>
            {cards.map((card, index) => (
              <motion.div
                key={card.label}
                custom={index}
                initial="hidden"
                animate="visible"
                variants={cardVariants}
                className={`relative flex gap-4 items-center p-5 rounded-xl bg-gradient-to-br ${card.gradient} text-white shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 group cursor-pointer`}
                whileHover={{ y: -5 }}
              >
                <div className="text-3xl p-3 bg-white/20 rounded-full backdrop-blur-sm">
                  {card.icon}
                </div>
                <div>
                  <div className="text-2xl font-bold">{card.value}</div>
                  <div className="text-sm font-medium">{card.label}</div>
                </div>
                <div className="absolute invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-gray-800 text-white text-xs rounded-md py-2 px-3 -top-10 left-1/2 transform -translate-x-1/2 z-10">
                  {card.tooltip}
                  <div className="absolute w-2 h-2 bg-gray-800 rotate-45 -bottom-1 left-1/2 -translate-x-1/2"></div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>

      {/* Table Section */}
      <div className="mt-8 shadow-xl rounded-2xl bg-white/80 backdrop-blur-md">
        <Leave_request_table organization={selectedOrganization} />
      </div>
    </div>
  );
};

export default Leave_Request;